import React from 'react';
import Box from '@mui/material/Box';
import { NumericTextField } from '@/components';

interface CollarODRowProps {
  collarOd: number | null;
  h: number | null;
  onCollarOdChange: (value: number | null) => void;
  onHChange: (value: number | null) => void;
  disabled?: boolean;
  collarOdError?: string;
  hError?: string;
}

/**
 * CollarODRow — Collar OD and H fields.
 */
const CollarODRow: React.FC<CollarODRowProps> = ({
  collarOd,
  h,
  onCollarOdChange,
  onHChange,
  disabled = false,
  collarOdError,
  hError,
}) => (
  <Box display="flex" gap={2}>
    <NumericTextField
      label="Collar OD [mm]"
      value={collarOd}
      onChange={onCollarOdChange}
      disabled={disabled}
      error={!!collarOdError}
      helperText={collarOdError}
      size="small"
      fullWidth
    />

    <NumericTextField
      label="H [mm]"
      value={h}
      onChange={onHChange}
      disabled={disabled}
      error={!!hError}
      helperText={hError}
      size="small"
      fullWidth
    />
  </Box>
);

export default React.memo(CollarODRow);
